export default __webpack_public_path__ + "f519472ad60ea4dbeb0b444c67f3ad22.svg";